export default {
    DEVELOPMENT: 'development',
    DEV_LOCAL: 'dev',
    DEV: 'dev',
    UAT: 'uat',
    NON_PROD: 'nonprod',
    PRODUCTION: 'production',
    PRD: 'prd',
    PROD: 'prod',
    nonprod: 'development', // key expected from REACT_APP_ENV env
    uat: 'uat', // key expected from REACT_APP_ENV env
    prod: 'prod', // key expected from REACT_APP_ENV env
};
